import WIDGETS from './widgets';

export default {
	name: 'admin_organization_management',
	spacing: 2,
	widgets: [{ content: WIDGETS.ORGANIZATIONS, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
